import React from 'react';
import { Card } from './Card';

export const CardSong = ({data, id}) => {
  const title = data.versions[0].version_info.title;

  const header = (
    <React.Fragment>
      {title}
    </React.Fragment>
  );

  const meta = (
    <React.Fragment>
      {data.composer.first_name} {data.composer.last_name}
    </React.Fragment>
  );

  return (
    <Card model='songs' header={header} meta={meta} id={data.song.id} color='green'/>
  );
};